import Vue from "vue";
import Vuex from "vuex";
import _ from "lodash";

import actions from "./actions";
import getters from "./getters";

import mutations from "./mutations";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentGroupID: "all",
    currentReloadActionID: '',
    currentReloadProgress: {},
    currentTestConnectionProgress: {},
    currentCloneBackupProgress: {},
    sites: [],
    appInfo: {},
    panelUpdateInfo: {},
    addonsUpdateInfo: false,
    settings: {},
    groups: [],
    selectedSites: [],
    selectedGroups: [],
    panelHistory: [],
    sitesUpdates: [],
    pluginsAndThemes: [],
    clientPluginUpdateSites: [],
    lastReloadTime: null,
    reloadStats:{},
    installedAddons:{},
    favorites: {
      plugins: [],
      themes: [],
      themeGroups: [],
      pluginGroups: []
    },
    menus:[],
    editSiteMenu:[],
    settingsMenu:[],
    siteInfoMenu:[],
    stopHistoryCheckCall: false,
    currentUserInfoV3: {},
    initPage: ""
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  strict: true,
});
